import React from "react";
import { useParams, useNavigate } from "react-router-dom";
import {
  Box,
  Heading,
  Text,
  VStack,
  HStack,
  Container,
  Center,
  Link,
  Button,
  AspectRatio,
} from "@chakra-ui/react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faMapMarkerAlt,
  faPhone,
  faFax,
  faEnvelope,
} from "@fortawesome/free-solid-svg-icons";

const ContactPage = () => {
  const navigate = useNavigate();
  return (
    <Box w="100%" bg="white" borderRadius="2xl" py={10}>
      <Center>
        <Container maxW="container.md">
          <VStack spacing={8} align="stretch">
            <Heading
              textAlign="center"
              color="teal.500"
              fontSize={{ base: "2xl", md: "3xl" }}
            >
              ติดต่อเรา
            </Heading>
            <VStack
              spacing={4}
              bg="gray.50"
              p={6}
              borderRadius="lg"
              boxShadow="md"
              align="start"
            >
              <Heading
                as="h2"
                fontSize={{ base: "lg", md: "xl" }}
                color="teal.600"
              >
                สำนักเทคโนโลยีชีวภัณฑ์สัตว์
              </Heading>
              <HStack spacing={3}>
                <FontAwesomeIcon icon={faMapMarkerAlt} color="teal" size="lg" />
                <Text fontSize={{ base: "sm", md: "md" }}>
                  1213 หมู่ 11 ต.ปากช่อง อ.ปากช่อง จ.นครราชสีมา 30130
                </Text>
              </HStack>
              <HStack spacing={3}>
                <FontAwesomeIcon icon={faPhone} color="teal" size="lg" />
                <Text fontSize={{ base: "sm", md: "md" }}>
                  โทรศัพท์: 044-311476 ต่อ 1140
                </Text>
              </HStack>
              <HStack spacing={3}>
                <FontAwesomeIcon icon={faFax} color="teal" size="lg" />
                <Text fontSize={{ base: "sm", md: "md" }}>
                  โทรสาร: 044-315931
                </Text>
              </HStack>
              <HStack spacing={3}>
                <FontAwesomeIcon icon={faEnvelope} color="teal" size="lg" />
                <Text fontSize={{ base: "sm", md: "md" }}>
                  อีเมล:{" "}
                  <Link
                    href="mailto:biologic@dld.go.th"
                    color="teal.500"
                    isExternal
                  >
                    biologic@dld.go.th
                  </Link>
                </Text>
              </HStack>
            </VStack>
            
            <Box>
              <Heading
                as="h3"
                fontSize={{ base: "md", md: "lg" }}
                color="teal.600"
                mb={4}
                textAlign="center"
              >
                แผนที่สำนักเทคโนโลยีชีวภัณฑ์สัตว์
              </Heading>
              <AspectRatio ratio={16 / 9}>
                <iframe
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3872.991891991135!2d101.4190308!3d14.6959497!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMTTCsDQxJDU3LjQiTiAxMDHCsDI1JTA4LjUiRQ!5e0!3m2!1sen!2sth!4v1698765432100"
                  width="100%"
                  height="100%"
                  style={{ border: 0 }}
                  allowFullScreen=""
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                  title="สำนักเทคโนโลยีชีวภัณฑ์สัตว์"
                ></iframe>
              </AspectRatio>
            </Box>
            <Button
              colorScheme="teal"
              variant="outline"
              size="sm"
              w="120px"
              onClick={() => navigate("/")}
            >
              ย้อนกลับ
            </Button>
          </VStack>
        </Container>
      </Center>
    </Box>
  );
};

export default ContactPage;
